import { ENUM_UTILS__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__field_kind } from '@shared/dto/generation/graph_invoke/_enums/ENUM__field_kind';
import { ENUM__field_group_type } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/ENUM__field_group_type';
import { G_DROPDOWN__filter_generation_inputs__bundle_status } from './G_DROPDOWN__filter_generation_inputs__bundle_status';
import { G_LIST_OF_CHECKBOXES__filter_generation_inputs } from './G_LIST_OF_CHECKBOXES__filter_generation_inputs';
import { G_FILTER__RADIO_GROUP__inputs_field_type } from './G_RADIO_GROUP__filter_generation_inputs';
import { G_BUTTON__fields_store_clean } from './_buttons/G_BUTTON__fields_store_clean';
import { G_BUTTON__fields_store_copy } from './_buttons/G_BUTTON__fields_store_copy';

export function G_SIDEBAR__inputs_filters() {
  return (
    <div className="w-full flex-1 bg-bar  min-w-0 flex flex-col overflow-y-auto">
      <div
        className="px-2 py-1 w-full
        text-xs text-bar-foreground
        font-semibold
        "
      >
        FILTERS
      </div>
      <G_DROPDOWN__filter_generation_inputs__bundle_status />

      <G_FILTER__RADIO_GROUP__inputs_field_type label="Shared Between Tools" filter_key="is_shared_between_tools">
        <G_BUTTON__fields_store_copy />
        <G_BUTTON__fields_store_clean />
      </G_FILTER__RADIO_GROUP__inputs_field_type>

      <G_FILTER__RADIO_GROUP__inputs_field_type label="Readonly" filter_key="is_readonly" />

      <G_FILTER__RADIO_GROUP__inputs_field_type label="Show only sources" filter_key="is_only_sources" />

      <G_FILTER__RADIO_GROUP__inputs_field_type label="Has Effect on Generation" filter_key="is_has_effect_on_generation" />

      <G_LIST_OF_CHECKBOXES__filter_generation_inputs label="Kind" filter_key="field_kind" values_all={Object.values(ENUM__field_kind)} />
      <G_LIST_OF_CHECKBOXES__filter_generation_inputs label="Type" filter_key="field_group_type" values_all={Object.values(ENUM__field_group_type)} />
      <G_LIST_OF_CHECKBOXES__filter_generation_inputs
        label="Family"
        filter_key="field_family"
        values_all={ENUM_UTILS__ml_asset_family.get_families_for_filter()}
      />
    </div>
  );
}
